import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import ContactContent from './components/ContactContent';
import Footer from '../home/components/Footer';
import { usePageMeta, useSchemaOrg } from '../../utils/seo';

export default function ContactUs() {
  usePageMeta(
    'Contact Piano Movers UK | Call 020 3441 9463',
    'Contact Piano Movers UK for a free fixed-price quote. Call 020 3441 9463 or email thenorthpiano@googlemail.com. Mon-Fri 08:30-18:00, Sat 08:30-15:00.',
    'contact piano movers London, piano removal quote London, piano movers contact, piano moving London enquiry',
    'https://www.pianomovers.co.uk/contact-us',
    'Contact Piano Movers UK | Call 020 3441 9463',
    'Contact Piano Movers UK for a free fixed-price quote. Call 020 3441 9463. Mon-Fri 08:30-18:00, Sat 08:30-15:00.',
    'Contact Piano Movers UK | 020 3441 9463',
    'Contact Piano Movers UK for a free fixed-price quote. Call 020 3441 9463. Mon-Fri 08:30-18:00, Sat 08:30-15:00.'
  );

  useSchemaOrg({
    type: 'LocalBusiness',
    data: {
      name: 'Piano Service North London',
      url: 'https://pianomovers.co.uk',
      telephone: '+442034419463',
      email: 'thenorthpiano@googlemail.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '176 Millicent Grove',
        addressLocality: 'London',
        postalCode: 'N13 6HS',
        addressCountry: 'GB',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 51.6185,
        longitude: -0.1,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:30',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '08:30',
          closes: '15:00',
        },
      ],
    },
  });

  return (
    <div className="bg-[#f5f5f0] text-[#1a1916]">
      <Navbar />
      <Hero />
      <ContactContent />
      <div className="bg-[#1a1916] py-4 text-center">
        <p className="text-[#d4d4ce] text-xs">
          Piano Movers UK is an independent guide to piano removal services in London.
        </p>
      </div>
      <Footer />
    </div>
  );
}